import { isTaskUuid } from '@erp/shared-utils';

/**
 * Id to use for UUID-only task APIs (timeline, subtasks) when the route
 * param may be a display id (`AP-1234`). Prefer the loaded row's UUID;
 * if the URL is already a UUID, use it immediately so those queries can
 * run in parallel with `tasks.get`.
 */
export function resolveTaskQueryId(
  urlTaskId: string,
  loadedTaskId: string | undefined,
): string | undefined {
  if (loadedTaskId) return loadedTaskId;
  if (isTaskUuid(urlTaskId)) return urlTaskId.trim();
  return undefined;
}
